import React from 'react'
import Footer from "../Footer"

import { LayoutProps } from './types'

import './style.scss'

function Layout(props: LayoutProps) {

  return (
    <>

    <main>
      {props.children}
    </main>
    <Footer/>
    </>
  )
}

export default Layout
